import { BulkAction, Dialog, Pagination, TabActionDialog } from "@saleor/types";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { Filters, FiltersWithMultipleValues, Sort } from "../types";

export const dispatchSectionUrl = "/dispatch";
export const batchAssignmentListPath = dispatchSectionUrl + "/batch-assignment";
export const dispatchHistoryListPath = dispatchSectionUrl + "/dispatch-history";
export const tripInformationListPath = dispatchHistoryListPath;

export type DispatchListUrlDialog =
  | TabActionDialog
  | "onAssignRider"
  | "onDelete";

export enum DispatchHistoryUrlFiltersWithMultipleValuesEnum {
  deliveryType = "deliveryType",
  verticalType = "verticalType"
}

export type DispatchListUrlQueryParams = BulkAction &
  Dialog<DispatchListUrlDialog> &
  Pagination & {
    id?: string;
  } & DispatchHistoryUrlFilters &
  DispatchHistoryUrlSort &
  Pagination;

export const batchAssignmentListUrl = (params?: DispatchListUrlQueryParams) =>
  batchAssignmentListPath + "?" + stringifyQs(params);

export const dispatchHistoryListUrl = (params?: DispatchListUrlQueryParams) =>
  dispatchHistoryListPath + "?" + stringifyQs(params);

export const tripInformationPath = (id: string) =>
  urlJoin(tripInformationListPath, id);

export const tripInformationUrl = (
  id: string,
  params?: DispatchListUrlQueryParams
) => tripInformationPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export enum DispatchHistoryUrlFiltersEnum {
  riderFirstName = "riderFirstName",
  riderLastName = "riderLastName",
  dateDispatchedFrom = "dateDispatchedFrom",
  dateDispatchedTo = "dateDispatchedTo",
  batchCode = "batchCode",
  deliveryDateRangeFrom = "deliveryDateRangeFrom",
  deliveryDateRangeTo = "deliveryDateRangeTo"
}

export type DispatchHistoryUrlFilters = Filters<DispatchHistoryUrlFiltersEnum> &
  FiltersWithMultipleValues<DispatchHistoryUrlFiltersWithMultipleValuesEnum>;

export enum DispatchHistoryUrlSortField {
  number = "number",
  customer = "customer",
  date = "date",
  fulfillment = "status",
  payment = "payment",
  total = "total"
}

export type DispatchHistoryUrlSort = Sort<DispatchHistoryUrlSortField>;
